import React, { type FC } from "react";
import type { FullQuickSpecConfigType } from "../../../../../shared-logic/utils/uscUtils";
import { useUscSelector } from "../../../../redux/store";
import EfficiencyClassLabel from "../../../../../shared-components/toyota/efficiency-class/EfficiencyClassLabel";

type Props = { spec: FullQuickSpecConfigType };

const EfficiencyClassSpec: FC<Props> = ({ spec }) => {
    const product = useUscSelector((state) => state.vehicle.result?.product);

    if (!product) return null;

    return <EfficiencyClassLabel ecoInfo={product.eco} code={spec.value} />;
};

export default EfficiencyClassSpec;
